// extracted by mini-css-extract-plugin
export default {"form-card":"Common_form-card__sy7wl","form-title":"Common_form-title__lHmeG","form-desc":"Common_form-desc__5MLp3"};